import styled from "styled-components/macro";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";
import logo from "../../images/logo.svg";
import { DropdownItem } from "reactstrap";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const Nav = styled.nav`
  ${"" /* background: ${({scrollNav, bgLogin}) => ( bgLogin? '#fff': (scrollNav? 'white': 'white'))}; */}
  /* background: ${({ bgLogin }) => (bgLogin ? "#fff" : "")}; */
  height: 80px;
  margin-top: -80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0px;
  z-index: 10;
  border: none;
  /* background-color: red; */

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }

  @media screen and (max-width: 480px) {
    height: 60px;
    transition: 0s all ease-in-out;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0rem 2rem;
  max-width: 1200px;
  box-shadow: 0px 4px 20px #0000000f;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  opacity: 1;
  background-color: white;
  position: relative;
  /* background-color: yellow; */
  direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
  @media screen and (max-width: 1024px) {
    padding: 0rem 1rem;
  }
  @media screen and (max-width: 799px) {
    width: 95%;
  }
`;

export const NavLogo = styled(LinkR)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  /* font-size: 1.5rem; */
  display: flex;
  align-items: center;
  /* margin-left: 24px; */
  /* font-weight: bold; */
  text-decoration: none;

  .logoImage {
    width: 90%;
    margin-right: 1.6rem;
  }

  @media screen and (max-width: 940px) {
    /* margin-left: 10px; */
    /* margin-right: 1.6rem; */
    .logoImage {
      width: 100%;
    }
  }
  @media screen and (max-width: 480px) {
    /* margin-left: 10px; */
    /* margin-right: 1.6rem; */
    .logoImage {
      width: 80%;
      margin-right: 0rem;
    }
  }

  @media screen and (max-width: 430px) {
    /* margin-left: 10px; */
    /* margin-right: 1.6rem; */
    .logoImage {
      width: 80%;
    }
  }
`;
export const SvgLogo = styled.img`
  /* color: #fff; */
  ${"" /* background: url(${logo}) no-repeat center center / cover; */}
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 1rem;
    /* top: -10px;
    left: 4rem; */
    /* right: 0; */
    /* transform: translate(-100%, 60%); */
    font-size: 1.8rem;
    cursor: pointer;
  }

  @media screen and (max-width: 553px) {
    left: 3.5rem;
  }
  @media screen and (max-width: 480px) {
    font-size: 1.5em;
    /* top: -5px; */
  }
  @media screen and (max-width: 437px) {
    margin-right: 0.3rem;
  }
  @media screen and (max-width: 361px) {
    font-size: 1.2em;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-left: auto;

  @media screen and (max-width: 1366px) {
    margin-right: 0px;
    /* margin-left: 0rem; */
  }

  @media screen and (max-width: 1224px) {
    margin-left: 1rem;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const NavItem = styled.li`
  height: 80px;
`;

export const NavLinks = styled.div`
  color: #000000;
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 100%;
  cursor: pointer;
  font-size: 1em;
  font-weight: 400;
  white-space: nowrap;
  margin-right: 2rem;

  @media screen and (max-width: 1099px) {
    margin-right: 1rem;
    font-size: 0.9em;
  }
  @media screen and (max-width: 881px) {
    margin-right: 1rem;
    font-size: 0.8em;
  }
  @media screen and (max-width: 799px) {
    margin-right: 0.5rem;
    font-size: 0.7em;
  }
  /* @media screen and (max-width: 403px) {
    margin-right: 1rem;
  } */

  /* &.active {
        color : #ED7D2B;
        border-bottom: 3px solid #ED7D2B;
    } */
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    /* display: none; */
  }
`;


export const NavBtnLink = styled(LinkR)`
  margin: 0.4em;
  border-radius: 4px;
  white-space: nowrap;
  padding: 0.6em 1.2em;
  color: ${(props) => (props.primary ? "#15396D" : "#F1F1F1")};
  background: ${(props) => (props.primary ? "transparent" : "#ED7D2B")};
  border: 1px solid ${(props) => (props.primary ? "#15396D" : "#ED7D2B")};
  font-size: 1em;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  font-family: "Montserrat";
  font-weight: 500;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${(props) => (props.primary ? "transparent" : "#FF4001")};
    color: ${(props) => (props.primary ? "FFFFFF" : "#FFFFFF")};
  }

  @media screen and (max-width: 1099px) {
    font-size: 0.9em;
  }

  @media screen and (max-width: 1024px) {
    padding: 0.6em;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const LoginTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
`;

export const LoginTitleMiddle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoginCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const LoginAnchor = styled.a`
  color: #2b3bf6;
`;

export const Profilelabel = styled.label`
  color: #0088ff;
  cursor: pointer;
  width: 100%;
  text-align: center !important;
`;

export const FlagDropdown = styled.div`

  @media screen and (max-width: 768px) {
    display: inline-block;
  }
`;

export const NavLogoFlag = styled.div`
  display: flex;
  align-items: center;
  /* margin-left: 2.3rem; */
`;

export const NavProfile = styled.div`
  color: #000000;
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 100%;
  cursor: pointer;
  font-size: 1em;
  font-weight: 400;
  white-space: nowrap;

  @media screen and (max-width: 1099px) {
    font-size: 0.9em;
  }
`;

export const FlagWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem 0.4rem;
`;

export const FlagIconBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const FlagPic = styled.img`
  width: 27%;
`;

export const FlagText = styled.div`
  margin-left: ${defaultLanguage === "ar" ? "0" : "0.5rem"};
  margin-right: ${defaultLanguage === "ar" ? "0.5rem" : "0"};
`;

export const FlagCheck = styled.div`
  background: #0288d1;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 50% !important;
`;

export const ProfileMenuWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem 1rem;
  background: #f5fafe 0% 0% no-repeat padding-box;
  border-radius: 8px;
  box-shadow: 0px 4px 32px #00000014;
`;

export const DdItem = styled(DropdownItem)`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 4px 32px #00000014;
  &:hover,
  &:focus {
    background: transparent;
    color: black;

    ${ProfileMenuWrap} {
      background: #15396d1f;
    }
  }
`;

export const ProfileMenuIcon = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const ProfileMenuPic = styled.img`
  width: 27%;
`;

export const ProfileMenuText = styled.div`
  margin-left: ${defaultLanguage === "ar" ? "0" : "0.5rem"};
  margin-right: ${defaultLanguage === "ar" ? "0.5rem" : "0"};
`;

export const ProfileDropdown = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    margin-right: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const CheckStatusMob = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
    margin-right: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const CheckStatusBtnMob = styled.div`
  border-radius: 4px;
  white-space: nowrap;
  padding: 0.4em;
  color: #15396d;
  border: 1px solid #15396d;
  font-size: 0.7em;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${(props) => (props.primary ? "transparent" : "#15396d")};
    color: ${(props) => (props.primary ? "FFFFFF" : "#FFFFFF")};
  }

  @media screen and (max-width: 1099px) {
    /* margin: 0.2em; */
    font-size: 0.9em;
  }

  @media screen and (max-width: 1024px) {
    /* padding: 0.6em; */
  }
`;

export const CheckStatusBtn = styled.div`
  margin: 0.4em;
  border-radius: 4px;
  white-space: nowrap;
  padding: 0.6em 1.2em;
  color: #15396d;
  border: 1px solid #15396d;
  font-size: 1em;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${(props) => (props.primary ? "transparent" : "#15396d")};
    color: ${(props) => (props.primary ? "FFFFFF" : "#FFFFFF")};
  }

  @media screen and (max-width: 1099px) {
    /* margin: 0.2em; */
    font-size: 0.9em;
  }

  @media screen and (max-width: 1024px) {
    /* padding: 0.6em; */
  }
`;

export const NotificationIcon = styled.img`
  margin: 0 0.2rem 0 0.8rem;
  @media (max-width: 835px) {
    height: 40px;
    width: 40px;
  }
  @media (max-width: 461px) {
    height: 40px;
    width: 40px;
  }
  @media (max-width: 424px) {
    margin: 0;
  }
  @media screen and (max-width: 385px) {
    height: 34px;
    width: 34px;
  }
`;
export const AddToNumber = styled.div`
  height: auto;
  width: auto;
  background: #4494fc 0% 0% no-repeat padding-box;
  border: 1px solid #ffffff;
  opacity: 1;
  text-align: center;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: Sans;
  letter-spacing: 0px;
  color: #ffffff;
  border-radius: 50%;
  position: absolute;
  margin-left: 50px;
  margin-top: -50px;

  @media screen and (max-width: 836px) {
    margin-left: 40px;
  }

  @media screen and (max-width: 425px) {
    margin-left: 25px;
  }
`;

export const SellPropButton = styled.div`
  margin: 0.4em;
  border-radius: 4px;
  white-space: nowrap;
  padding: 0.6em 1.2em;
  color: ${(props) => (props.primary ? "#15396D" : "#F1F1F1")};
  background: ${(props) => (props.primary ? "transparent" : "#ED7D2B")};
  border: 1px solid ${(props) => (props.primary ? "#15396D" : "#ED7D2B")};
  font-size: 1em;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  font-family: "Montserrat";
  font-weight: 500;

  @media screen and (max-width: 922px) {
    font-size: 0.8em;
  }
  @media screen and (max-width: 858px) {
    font-size: 0.7em;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
